<div class="onboarding">
  <edu-card>
    <div class="student-info" *ngIf="student">
      <h2 edu-card-title>{{ student.userName }} - {{ student.fullName }}</h2>
    </div>
    <div class="onboarding-title" *ngIf="!student">
      <h2 edu-card-title>Onboarding Steps</h2>
    </div>
    <div class="onboarding-steps">
      <ng-container
        *ngIf="onboardingSteps && onboardingSteps.length > 0; else emptyOnboarding"
      >
        <div
          class="step-wrapper"
          *ngFor="let step of onboardingSteps; let i = index"
        >
          <!-- Timeline -->
          <div class="timeline">
            <div
              class="circle"
              [ngClass]="{ completed: step.completed, pending: !step.completed }"
            ></div>
            <div
              class="line"
              *ngIf="i < onboardingSteps.length - 1"
              [ngClass]="{ completed: onboardingSteps[i + 1]?.completed }"
            ></div>
          </div>

          <!-- Step content: Use ng-template for admin/student view -->
          <ng-container *ngIf="viewType === 'admin'; else studentStep">
            <div class="step step-disabled">
              <div class="step-info">
                <p class="completed-at" *ngIf="step.completedAt">
                  {{ step.completedAt | date: "dd MMM yy" }}
                </p>
                <h3 class="step-name">{{ step.step.name }}</h3>
                <p class="step-description">{{ step.step.description }}</p>
              </div>
              <div class="step-status">
                <span
                  [ngClass]="{
                    completed: step.completed,
                    pending: !step.completed,
                  }"
                >
                  {{ step.completed ? "Completed" : "Pending" }}
                </span>
                <!-- No icon and no icon-placeholder for admin view -->
              </div>
              <mat-divider
                class="step-divider"
                *ngIf="i < onboardingSteps.length - 1"
              ></mat-divider>
            </div>
          </ng-container>
          <ng-template #studentStep>
            <div class="step" (click)="onclickstep()">
              <div class="step-info">
                <p class="completed-at" *ngIf="step.completedAt">
                  {{ step.completedAt | date: "dd MMM yy" }}
                </p>
                <h3 class="step-name">{{ step.step.name }}</h3>
                <p class="step-description">{{ step.step.description }}</p>
              </div>
              <div class="step-status">
                <span
                  [ngClass]="{
                    completed: step.completed,
                    pending: !step.completed,
                  }"
                >
                  {{ step.completed ? "Completed" : "Pending" }}
                </span>
                <mat-icon
                  *ngIf="!step.completed"
                  fontIcon="keyboard_arrow_right"
                  aria-label="Go to step"
                ></mat-icon>
                <div *ngIf="step.completed" class="icon-placeholder"></div>
              </div>
              <mat-divider
                class="step-divider"
                *ngIf="i < onboardingSteps.length - 1"
              ></mat-divider>
            </div>
          </ng-template>
        </div>
      </ng-container>
      <ng-template #emptyOnboarding>
        <div class="empty-onboarding">
          <img src="assets/meetings/no-meetings.svg" alt="No onboarding steps" />
          <p>No onboarding steps to display.</p>
        </div>
      </ng-template>
    </div>
  </edu-card>
</div>
